import * as z from "zod";

const resolveAddressSchema = z.object({
  line1: z.string(),
  line2: z.string(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  country: z.string(),
});

const resolveBinSchema = z.object({
  acquirerBin: z.string(),
  caid: z.string(),
});

// The full RESOLVE merchant-profile draft (§5.5.3). Shared by the prefill output
// and the enroll input — the enroll form binds 1:1, the merchant reviews/edits,
// we submit. Declared here (not imported from the server-only Disputely client)
// to keep that client out of the browser SDK bundle.
export const resolveEnrollProfileSchema = z.object({
  merchantName: z.string(),
  merchantDescription: z.string(),
  merchantCategoryCodes: z.array(z.string()),
  merchantWebsite: z.string(),
  merchantEmail: z.string(),
  merchantPhone: z.string(),
  merchantAddress: resolveAddressSchema,
  terms: z.string(),
  termsUrl: z.string(),
  refundPolicy: z.string(),
  refundPolicyUrl: z.string(),
  customerServiceInstructions: z.string(),
  // Optional per API §5.5.3; default to "" so callers may omit them. The enroll
  // mapper (draftToBody) drops empties, so an omitted value is never sent.
  disputeOutcomeAction: z.string().default(""),
  additionalInfo: z.string().default(""),
  descriptors: z.array(z.string()),
  bins: z.array(resolveBinSchema),
  // Optional per API §5.5.3 (only when the merchant accepts Amex / Discover);
  // default to "" and dropped on submit when empty.
  amexSe: z.string().default(""),
  discoverMid: z.string().default(""),
  logoUrl: z.string(),
  locale: z.string(),
});

export const getDisputelyResolvePrefill = {
  name: "getDisputelyResolvePrefill" as const,
  input: z.object({}),
  output: resolveEnrollProfileSchema,
};
